export default "__VITE_ASSET__BVkiZYej__"